/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { replace } from 'react-router-redux';
import { connect } from 'react-redux';
import qs from 'qs';
import {
  Container,
  Grid,
  Menu,
  Dropdown,
  Segment,
  Divider,
  Loader,
  Dimmer,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import { fetchAddressSettings } from '../../actions/addressSettings';
import { decodeSearch, encodeSearch } from '../../utils/url';
import isNumber from '../../utils/numbers/isNumber';
import NavBar from '../../components/NavBar';
import PageNav from '../../components/PageNav';
import SortButton from '../../components/SortButton';
import BookingActivities from '../../components/BookingActivities';
import ProjectUnitActivities from '../../components/ProjectUnitActivities';
import ProjectActivities from '../../components/ProjectActivities';
import ExportActivities from '../../components/ExportActivities';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import UserActivities from '../../components/UserActivities';
import BusinessUnitActivities from '../../components/BusinessUnitActivities';
import SearchFilter from '../../components/SearchFilter';

class Overview extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isAdminBasic: PropTypes.bool,
    }),
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    t: PropTypes.func,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  static getPropsToState = (props) => {
    const query = decodeSearch(props.location.search);
    const bookingsCurrentPage = parseInt(query.page, 10) || 1;
    const unitsCurrentPage = parseInt(query.page, 10) || 1;
    const projectsCurrentPage = parseInt(query.page, 10) || 1;
    const exportsCurrentPage = parseInt(query.page, 10) || 1;
    const usersCurrentPage = parseInt(query.page, 10) || 1;
    const businessUnitsCurrentPage = parseInt(query.page, 10) || 1;
    const search = query.search || '';
    return {
      bookingsCurrentPage,
      unitsCurrentPage,
      projectsCurrentPage,
      exportsCurrentPage,
      usersCurrentPage,
      businessUnitsCurrentPage,
      search,
    };
  }
  constructor(props) {
    super(props);
    const menuIsTab = window.innerWidth <= 590;
    const state = Overview.getPropsToState(props);
    this.state = {
      ...state,
      loading: true,
      menuIsTab,
      bookingsData: [],
      bookingsLimit: 0,
      bookingsOffset: 0,
      bookingsCount: 0,
      unitsData: [],
      unitsLimit: 0,
      unitsOffset: 0,
      unitsCount: 0,
      projectsData: [],
      projectsLimit: 0,
      projectsOffset: 0,
      projectsCount: 0,
      exportsData: [],
      exportsLimit: 0,
      exportsOffset: 0,
      exportsCount: 0,
      usersData: [],
      usersLimit: 0,
      usersOffset: 0,
      usersCount: 0,
      businessUnitsData: [],
      businessUnitsLimit: 0,
      businessUnitsOffset: 0,
      businessUnitsCount: 0,
    };
  }
  componentWillMount() {
    const { store } = this.context;
    store.dispatch(fetchAddressSettings());
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
    const { store } = this.context;
    const { pathname, query } = this.props.location;
    if (pathname === '/activities/') {
      this.getBookingActivities(query);
      store.dispatch(replace('/activities/bookings/'));
    }
    if (pathname === '/activities/bookings/') {
      this.getBookingActivities(query);
    }
    if (pathname === '/activities/project_units/') {
      this.getProjectUnitActivities(query);
    }
    if (pathname === '/activities/projects/') {
      this.getProjectActivities(query);
    }
    if (pathname === '/activities/exports/') {
      this.getExportActivities(query);
    }
    if (pathname === '/activities/users/') {
      this.getUserActivities(query);
    }
    if (pathname === '/activities/business_units/') {
      this.getBusinessUnitActivities(query);
    }
  }
  componentWillReceiveProps(nextProps) {
    const { pathname, query } = nextProps.location;
    const state = Overview.getPropsToState(nextProps);
    if (pathname === '/activities/bookings/') {
      if (!this.state.bookingsData) {
        this.getBookingActivities(query);
      }
    }
    if (pathname === '/activities/project_units/') {
      if (!this.state.unitsData) {
        this.getProjectUnitActivities(query);
      }
    }
    if (pathname === '/activities/projects/') {
      if (!this.state.projectsData) {
        this.getProjectActivities(query);
      }
    }
    if (pathname === '/activities/users/') {
      if (!this.state.usersData) {
        this.getUserActivities(query);
      }
    }
    if (pathname === '/activities/business_units/') {
      if (!this.state.businessUnitsData) {
        this.getBusinessUnitActivities(query);
      }
    }
    this.setState({ ...state });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  async getBookingActivities(q) {
    const { t } = this.props;
    await this.setLoading(true);
    const { store } = this.context;
    const query = Object.assign({}, q);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    let queryString = '';
    let res = null;
    if (qs.stringify(query)) {
      queryString = `?${qs.stringify(query)}`;
    }
    try {
      res = await store.dispatch(fetchM(`/activities/bookings/${queryString}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
    }
    if (!res.ok) {
      await this.setLoading(false);
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
    } else {
      const bookingsData = await res.json();
      const bookingsCount = parseInt(res.headers.get('M-Data-count'), 10);
      const bookingsLimit = parseInt(res.headers.get('M-Data-limit'), 10);
      const bookingsOffset = parseInt(res.headers.get('M-Data-offset'), 10);
      await this.setComponentState({
        bookingsCount,
        bookingsLimit,
        bookingsOffset,
        bookingsData,
      });
      await this.setLoading(false);
    }
  }
  async getProjectUnitActivities(q) {
    const { t } = this.props;
    await this.setLoading(true);
    const { store } = this.context;
    const query = Object.assign({}, q);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    let queryString = '';
    let res = null;
    if (qs.stringify(query)) {
      queryString = `?${qs.stringify(query)}`;
    }
    try {
      res = await store.dispatch(fetchM(`/activities/project_units/${queryString}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
    }
    if (!res.ok) {
      await this.setLoading(false);
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
    } else {
      const unitsData = await res.json();
      const unitsCount = parseInt(res.headers.get('M-Data-count'), 10);
      const unitsLimit = parseInt(res.headers.get('M-Data-limit'), 10);
      const unitsOffset = parseInt(res.headers.get('M-Data-offset'), 10);
      await this.setComponentState({
        unitsCount,
        unitsLimit,
        unitsOffset,
        unitsData,
      });
      await this.setLoading(false);
    }
  }
  async getProjectActivities(q) {
    const { t } = this.props;
    await this.setLoading(true);
    const { store } = this.context;
    const query = Object.assign({}, q);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    let queryString = '';
    let res = null;
    if (qs.stringify(query)) {
      queryString = `?${qs.stringify(query)}`;
    }
    try {
      res = await store.dispatch(fetchM(`/activities/projects/${queryString}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
    }
    if (!res.ok) {
      await this.setLoading(false);
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
    } else {
      const projectsData = await res.json();
      const projectsCount = parseInt(res.headers.get('M-Data-count'), 10);
      const projectsLimit = parseInt(res.headers.get('M-Data-limit'), 10);
      const projectsOffset = parseInt(res.headers.get('M-Data-offset'), 10);
      await this.setComponentState({
        projectsCount,
        projectsLimit,
        projectsOffset,
        projectsData,
      });
      await this.setLoading(false);
    }
  }
  async getExportActivities(q) {
    const { t } = this.props;
    await this.setLoading(true);
    const { store } = this.context;
    const query = Object.assign({}, q);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    let queryString = '';
    let res = null;
    if (qs.stringify(query)) {
      queryString = `?${qs.stringify(query)}`;
    }
    try {
      res = await store.dispatch(fetchM(`/activities/exports/${queryString}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
    }
    if (!res.ok) {
      await this.setLoading(false);
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
    } else {
      const exportsData = await res.json();
      const exportsCount = parseInt(res.headers.get('M-Data-count'), 10);
      const exportsLimit = parseInt(res.headers.get('M-Data-limit'), 10);
      const exportsOffset = parseInt(res.headers.get('M-Data-offset'), 10);
      await this.setComponentState({
        exportsCount,
        exportsLimit,
        exportsOffset,
        exportsData,
      });
      await this.setLoading(false);
    }
  }
  async getUserActivities(q) {
    const { t } = this.props;
    await this.setLoading(true);
    const { store } = this.context;
    const query = Object.assign({}, q);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    let queryString = '';
    let res = null;
    if (qs.stringify(query)) {
      queryString = `?${qs.stringify(query)}`;
    }
    try {
      res = await store.dispatch(fetchM(`/activities/users/${queryString}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
    }
    if (!res.ok) {
      await this.setLoading(false);
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
    } else {
      const usersData = await res.json();
      const usersCount = parseInt(res.headers.get('M-Data-count'), 10);
      const usersLimit = parseInt(res.headers.get('M-Data-limit'), 10);
      const usersOffset = parseInt(res.headers.get('M-Data-offset'), 10);
      await this.setComponentState({
        usersCount,
        usersLimit,
        usersOffset,
        usersData,
      });
      await this.setLoading(false);
    }
  }
  async getBusinessUnitActivities(q) {
    await this.setLoading(true);
    const { t } = this.props;
    const { store } = this.context;
    const query = Object.assign({}, q);
    if (!query.page || !isNumber(query.page) || query.page <= 0) {
      query.page = 1;
    }
    let queryString = '';
    let res = null;
    if (qs.stringify(query)) {
      queryString = `?${qs.stringify(query)}`;
    }
    try {
      res = await store.dispatch(fetchM(`/activities/business_units/${queryString}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
    }
    if (!res.ok) {
      await this.setLoading(false);
      store.dispatch(flashErrorMessage({ message: t('There was an error with your request. Please try again.', { ns: TRANSLATION_FILES.translation }) }));
    } else {
      const businessUnitsData = await res.json();
      const businessUnitsCount = parseInt(res.headers.get('M-Data-count'), 10);
      const businessUnitsLimit = parseInt(res.headers.get('M-Data-limit'), 10);
      const businessUnitsOffset = parseInt(res.headers.get('M-Data-offset'), 10);
      await this.setComponentState({
        businessUnitsCount,
        businessUnitsLimit,
        businessUnitsOffset,
        businessUnitsData,
      });
      await this.setLoading(false);
    }
  }
  getTabName = () => {
    const { pathname } = this.props.location;
    if (pathname === '/activities/bookings/') {
      return 'bookings';
    }
    if (pathname === '/activities/project_units/') {
      return 'project_units';
    }
    if (pathname === '/activities/projects/') {
      return 'projects';
    }
    if (pathname === '/activities/exports/') {
      return 'exports';
    }
    if (pathname === '/activities/users/') {
      return 'users';
    }
    if (pathname === '/activities/business_units/') {
      return 'business_units';
    }
    return '';
  }
  hasAccess(check = false, hq = true, admin = true) {
    if (this.props.auth.isHeadquarters && hq) {
      return true;
    }
    if (this.props.auth.isAdminBasic && admin) {
      return true;
    }
    return check;
  }
  handleResize = () => {
    const menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== this.state.menuIsTab) {
      this.setState({ menuIsTab });
    }
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    if (value.includes('/activities/bookings/')) {
      this.getBookingActivities();
    }
    if (value.includes('/activities/project_units/')) {
      this.getProjectUnitActivities();
    }
    if (value.includes('/activities/projects/')) {
      this.getProjectActivities();
    }
    if (value.includes('/activities/exports/')) {
      this.getExportActivities();
    }
    if (value.includes('/activities/users/')) {
      this.getUserActivities();
    }
    if (value.includes('/activities/business_units/')) {
      this.getBusinessUnitActivities();
    }
    store.dispatch(replace(value));
  }
  handleClearFilter = () => {
    const query = decodeSearch(this.props.location.search);
    delete query.search;
    this.setState({
      search: '',
    }, () => {
      this.replaceQuery(query, true);
    });
  }
  handleFilterOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    this.replaceQuery(query, false);
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    let { bookingsCurrentPage, unitsCurrentPage, projectsCurrentPage, exportsCurrentPage, usersCurrentPage, businessUnitsCurrentPage } = this.state;
    if (this.getTabName() === 'bookings') {
      bookingsCurrentPage = currentPage;
    }
    if (this.getTabName() === 'project_units') {
      unitsCurrentPage = currentPage;
    }
    if (this.getTabName() === 'projects') {
      projectsCurrentPage = currentPage;
    }
    if (this.getTabName() === 'projects') {
      exportsCurrentPage = currentPage;
    }
    if (this.getTabName() === 'users') {
      usersCurrentPage = currentPage;
    }
    if (this.getTabName() === 'business_units') {
      businessUnitsCurrentPage = currentPage;
    }
    this.setState({
      bookingsCurrentPage,
      unitsCurrentPage,
      projectsCurrentPage,
      exportsCurrentPage,
      usersCurrentPage,
      businessUnitsCurrentPage,
    });
    this.replaceQuery(query);
  }
  handleSortData = (sortColumn, sortDirection) => {
    const query = decodeSearch(this.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    this.replaceQuery(query);
  }
  async replaceQuery(query, resetPage = false) {
    await this.setLoading(true);
    const { store } = this.context;
    const queryNew = query;
    if (resetPage) queryNew.page = 1;
    if (this.getTabName() === 'bookings') {
      await this.getBookingActivities(query);
    }
    if (this.getTabName() === 'project_units') {
      await this.getProjectUnitActivities(query);
    }
    if (this.getTabName() === 'projects') {
      await this.getProjectActivities(query);
    }
    if (this.getTabName() === 'exports') {
      await this.getExportActivities(query);
    }
    if (this.getTabName() === 'users') {
      await this.getUserActivities(query);
    }
    if (this.getTabName() === 'business_units') {
      await this.getBusinessUnitActivities(query);
    }
    store.dispatch(replace(`/activities/${this.getTabName()}/?${encodeSearch(queryNew)}`));
    await this.setLoading(false);
  }
  bookingsSortItems = [
    {
      text: 'Date Ascending',
      icon: 'sort alphabet ascending',
      sortColumn: 'booking_activity.created_at',
      sortDirection: 'asc',
    },
    {
      text: 'Date Descending',
      icon: 'sort alphabet descending',
      sortColumn: 'booking_activity.created_at',
      sortDirection: 'desc',
    },
  ];
  unitsSortItems = [
    {
      text: 'Date Ascending',
      icon: 'sort alphabet ascending',
      sortColumn: 'project_unit_activity.created_at',
      sortDirection: 'asc',
    },
    {
      text: 'Date Descending',
      icon: 'sort alphabet descending',
      sortColumn: 'project_unit_activity.created_at',
      sortDirection: 'desc',
    },
  ];
  projectsSortItems = [
    {
      text: 'Date Ascending',
      icon: 'sort alphabet ascending',
      sortColumn: 'project_activity.created_at',
      sortDirection: 'asc',
    },
    {
      text: 'Date Descending',
      icon: 'sort alphabet descending',
      sortColumn: 'project_activity.created_at',
      sortDirection: 'desc',
    },
  ];
  exportsSortItems = [
    {
      text: 'Date Ascending',
      icon: 'sort alphabet ascending',
      sortColumn: 'export_activity.created_at',
      sortDirection: 'asc',
    },
    {
      text: 'Date Descending',
      icon: 'sort alphabet descending',
      sortColumn: 'export_activity.created_at',
      sortDirection: 'desc',
    },
  ];
  usersSortItems = [
    {
      text: 'Date Ascending',
      icon: 'sort alphabet ascending',
      sortColumn: 'user_activity.created_at',
      sortDirection: 'asc',
    },
    {
      text: 'Date Descending',
      icon: 'sort alphabet descending',
      sortColumn: 'user_activity.created_at',
      sortDirection: 'desc',
    },
  ];
  businessUnitsSortItems = [
    {
      text: 'Date Ascending',
      icon: 'sort alphabet ascending',
      sortColumn: 'business_unit_activity.created_at',
      sortDirection: 'asc',
    },
    {
      text: 'Date Descending',
      icon: 'sort alphabet descending',
      sortColumn: 'business_unit_activity.created_at',
      sortDirection: 'desc',
    },
  ];
  render() {
    const { pathname } = this.props.location;
    const { t } = this.props;
    const { bookingsData, unitsData, projectsData, exportsData, usersData, businessUnitsData } = this.state;
    const links = [
      { text: 'Bookings', value: '/activities/bookings/' },
      { text: 'Project Units', value: '/activities/project_units/' },
      { text: 'Projects', value: '/activities/projects/' },
      { text: 'Data Exports', value: '/activities/exports/' },
      { text: 'Users', value: '/activities/users/' },
      { text: 'Business Units', value: '/activities/business_units/' },
    ];
    return (
      <Container>
        <NavBar
          header={t('Activity Logs')}
          links={
            this.state.menuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links}
                onChange={this.handleMenu}
                value={pathname}
                disabled={this.state.loading}
              />
            : links.map((link, key) => (
              <Menu.Item
                key={key}
                name={t(link.text)}
                active={pathname === link.value}
                onClick={e => this.handleMenu(e, link)}
              />
            ))
          }
        />
        <Grid>
          <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
            <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
          </Dimmer>
          <Grid.Row>
            <Grid.Column>
              { this.getTabName() === 'bookings' ?
                <Grid>
                  <Grid.Row>
                    <Grid.Column>
                      <Grid>
                        <Grid.Row>
                          <Grid.Column width={16}>
                            <SearchFilter
                              isLoading={this.state.loading}
                              onChange={this.handleFilterOnChange}
                              onClose={this.handleClearFilter}
                              search={this.state.search}
                              placeholder={t('Search by booking code', { ns: TRANSLATION_FILES.translation })}
                              leftNav={(
                                <PageNav
                                  currentPage={this.state.bookingsCurrentPage}
                                  count={this.state.bookingsCount}
                                  limit={this.state.bookingsLimit}
                                  offset={this.state.bookingsOffset}
                                  dataSize={this.state.bookingsData.length}
                                  loading={this.state.loading}
                                  onChange={this.handleChangePage}
                                />
                              )}
                              rightNav={(
                                <SortButton
                                  floated="right"
                                  loading={this.state.loading}
                                  items={this.bookingsSortItems}
                                  onSort={this.handleSortData}
                                />
                              )}
                            />
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                      <Grid.Column width={16} textAlign="center">
                        <Divider horizontal>
                          {t('Booking Activity Logs')}
                        </Divider>
                        <Segment>
                          <BookingActivities
                            data={bookingsData || []}
                            hasAccess={this.hasAccess()}
                            loading={this.state.loading}
                            showAll
                          />
                        </Segment>
                      </Grid.Column>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              : ''
              }
              { this.getTabName() === 'project_units' ?
                <Grid>
                  <Grid.Row>
                    <Grid.Column>
                      <Grid>
                        <Grid.Row>
                          <Grid.Column width={16}>
                            <SearchFilter
                              isLoading={this.state.loading}
                              onChange={this.handleFilterOnChange}
                              onClose={this.handleClearFilter}
                              search={this.state.search}
                              placeholder={t('Search by unit number', { ns: TRANSLATION_FILES.translation })}
                              leftNav={(
                                <PageNav
                                  currentPage={this.state.unitsCurrentPage}
                                  count={this.state.unitsCount}
                                  limit={this.state.unitsLimit}
                                  offset={this.state.unitsOffset}
                                  dataSize={this.state.unitsData.length}
                                  loading={this.state.loading}
                                  onChange={this.handleChangePage}
                                />
                              )}
                              rightNav={(
                                <SortButton
                                  floated="right"
                                  loading={this.state.loading}
                                  items={this.unitsSortItems}
                                  onSort={this.handleSortData}
                                />
                              )}
                            />
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                      <Grid.Column width={16} textAlign="center">
                        <Divider horizontal>
                          {t('Project Unit Activity Logs')}
                        </Divider>
                        <Segment>
                          <ProjectUnitActivities
                            data={unitsData || []}
                            hasAccess={this.hasAccess()}
                            loading={this.state.loading}
                            showAll
                          />
                        </Segment>
                      </Grid.Column>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              : ''
              }
              { this.getTabName() === 'projects' ?
                <Grid>
                  <Grid.Row>
                    <Grid.Column>
                      <Grid>
                        <Grid.Row>
                          <Grid.Column width={16}>
                            <SearchFilter
                              isLoading={this.state.loading}
                              onChange={this.handleFilterOnChange}
                              onClose={this.handleClearFilter}
                              search={this.state.search}
                              placeholder={t('Search by project name', { ns: TRANSLATION_FILES.translation })}
                              leftNav={(
                                <PageNav
                                  currentPage={this.state.projectsCurrentPage}
                                  count={this.state.projectsCount}
                                  limit={this.state.projectsLimit}
                                  offset={this.state.projectsOffset}
                                  dataSize={this.state.projectsData.length}
                                  loading={this.state.loading}
                                  onChange={this.handleChangePage}
                                />
                              )}
                              rightNav={(
                                <SortButton
                                  floated="right"
                                  loading={this.state.loading}
                                  items={this.projectsSortItems}
                                  onSort={this.handleSortData}
                                />
                              )}
                            />
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                      <Grid.Column width={16} textAlign="center">
                        <Divider horizontal>
                          {t('Project Activity Logs')}
                        </Divider>
                        <Segment>
                          <ProjectActivities
                            data={projectsData || []}
                            hasAccess={this.hasAccess()}
                            loading={this.state.loading}
                            showAll
                          />
                        </Segment>
                      </Grid.Column>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              : ''
              }
              {this.getTabName() === 'exports' ?
                <Grid>
                  <Grid.Row>
                    <Grid.Column>
                      <Grid>
                        <Grid.Row>
                          <Grid.Column width={16}>
                            <SearchFilter
                              isLoading={this.state.loading}
                              onChange={this.handleFilterOnChange}
                              onClose={this.handleClearFilter}
                              search={this.state.search}
                              placeholder={t('Search by export type or exported file name', { ns: TRANSLATION_FILES.translation })}
                              leftNav={(
                                <PageNav
                                  currentPage={this.state.exportsCurrentPage}
                                  count={this.state.exportsCount}
                                  limit={this.state.exportsLimit}
                                  offset={this.state.exportsOffset}
                                  dataSize={this.state.exportsData.length}
                                  loading={this.state.loading}
                                  onChange={this.handleChangePage}
                                />
                              )}
                              rightNav={(
                                <SortButton
                                  floated="right"
                                  loading={this.state.loading}
                                  items={this.exportsSortItems}
                                  onSort={this.handleSortData}
                                />
                              )}
                            />
                          </Grid.Column>
                        </Grid.Row>
                      </Grid>
                      <Grid.Column width={16} textAlign="center">
                        <Divider horizontal>
                          {t('Data Export Activity Logs')}
                        </Divider>
                        <Segment>
                          <ExportActivities
                            data={exportsData || []}
                            hasAccess={this.hasAccess()}
                            loading={this.state.loading}
                            showAll={this.hasAccess(false, false, true)}
                          />
                        </Segment>
                      </Grid.Column>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
                : ''
              }
              {
                this.getTabName() === 'users' ?
                  <Grid>
                    <Grid.Row>
                      <Grid.Column>
                        <Grid>
                          <Grid.Row>
                            <Grid.Column width={16}>
                              <SearchFilter
                                isLoading={this.state.loading}
                                onChange={this.handleFilterOnChange}
                                onClose={this.handleClearFilter}
                                search={this.state.search}
                                placeholder={t('Search by user name', { ns: TRANSLATION_FILES.translation })}
                                leftNav={(
                                  <PageNav
                                    currentPage={this.state.usersCurrentPage}
                                    count={this.state.usersCount}
                                    limit={this.state.usersLimit}
                                    offset={this.state.usersOffset}
                                    dataSize={this.state.usersData.length}
                                    loading={this.state.loading}
                                    onChange={this.handleChangePage}
                                  />
                                )}
                                rightNav={(
                                  <SortButton
                                    floated="right"
                                    loading={this.state.loading}
                                    items={this.usersSortItems}
                                    onSort={this.handleSortData}
                                  />
                                )}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                        <Grid.Column width={16} textAlign="center">
                          <Divider horizontal>
                            {t('User Activity Logs')}
                          </Divider>
                          <Segment>
                            <UserActivities
                              data={usersData || []}
                              hasAccess={this.hasAccess()}
                              loading={this.state.loading}
                              showAll
                            />
                          </Segment>
                        </Grid.Column>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                  : ''
              }
              {
                this.getTabName() === 'business_units' ?
                  <Grid>
                    <Grid.Row>
                      <Grid.Column>
                        <Grid>
                          <Grid.Row>
                            <Grid.Column width={16}>
                              <SearchFilter
                                isLoading={this.state.loading}
                                onChange={this.handleFilterOnChange}
                                onClose={this.handleClearFilter}
                                search={this.state.search}
                                placeholder={t('Search by business unit name', { ns: TRANSLATION_FILES.translation })}
                                leftNav={(
                                  <PageNav
                                    currentPage={this.state.businessUnitsCurrentPage}
                                    count={this.state.businessUnitsCount}
                                    limit={this.state.businessUnitsLimit}
                                    offset={this.state.businessUnitsOffset}
                                    dataSize={this.state.businessUnitsData.length}
                                    loading={this.state.loading}
                                    onChange={this.handleChangePage}
                                  />
                                )}
                                rightNav={(
                                  <SortButton
                                    floated="right"
                                    loading={this.state.loading}
                                    items={this.businessUnitsSortItems}
                                    onSort={this.handleSortData}
                                  />
                                )}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                        <Grid.Column width={16} textAlign="center">
                          <Divider horizontal>
                            {t('Business Unit Activity Logs')}
                          </Divider>
                          <Segment>
                            <BusinessUnitActivities
                              data={businessUnitsData || []}
                              hasAccess={this.hasAccess()}
                              loading={this.state.loading}
                              showAll
                            />
                          </Segment>
                        </Grid.Column>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                  : ''
              }
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(Overview.mapStateToProps)(Overview));



// WEBPACK FOOTER //
// ./src/containers/Activities/Overview.jsx